import React from "react";
import Preloader from "@tinqin/tinqin-ui-components/src/preloader";
export default function ScrollLoading() {
    return <Preloader center minHeight={"50px"} />;
}
